<template>
  <div class="container">
    <div class="handle-box">
      <el-form :model="queryCondition" ref="queryCondition" label-width="140px" class="searchForm">
        <el-row>
          <el-col :span="24">
            <el-row :gutter="20">
              <el-col :span="6">
                <el-form-item :label="$t(`${type}Manage.${type}No`)" prop="serialNo">
                  <!--SSR编号-->
                  <el-input v-model.trim="queryCondition.serialNo" clearable style="width:100%"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item :label="$t(`${type}Manage.${type}Name`)" prop="name">
                  <!--SSR名称-->
                  <el-input v-model.trim="queryCondition.name" clearable style="width:100%"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="Initiator" prop="creator">
                  <!--创建人-->
                  <el-input v-model.trim="queryCondition.creator" clearable style="width:100%"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item :label="'Status'" prop="status">
                  <!--状态-->
                  <ic-select clearable table="TT_SSR" field="STATUS_VIEW" v-model="queryCondition.status" style="width:100%" :placeholder="$t('BC.sel')"></ic-select>
                </el-form-item>
              </el-col>
            </el-row>
          </el-col>
          <el-collapse-transition>
            <el-col :span="24" v-if="isShow">
              <el-row :gutter="20">
                <el-col :span="6">
                  <el-form-item :label="$t('ssrManage.category1')" prop="category1Id">
                    <el-select v-model="queryCondition.category1Id" clearable @change="changeCategory1()" style="width:100%" :placeholder="$t('BC.sel')">
                      <el-option :key="index" v-for="(item,index) in categoryList1" :label="item.name" :value="item.tmCategoryId"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item :label="$t('ssrManage.category2')" prop="category2Id">
                    <!--category2-->
                    <el-select v-model="queryCondition.category2Id" clearable style="width:100%" :placeholder="$t('BC.sel')">
                      <el-option :key="index" v-for="(item,index) in categoryList2" :label="item.name" :value="item.tmCategoryId"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="Release Date(From)" prop="issueDateFrom">
                    <el-date-picker value-format="yyyy-MM-dd" v-model="queryCondition.issueDateFrom" type="date" :placeholder="'Select Date'" style="width: 100%;"></el-date-picker>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="Release Date(To)" prop="issueDateTo">
                    <el-date-picker value-format="yyyy-MM-dd" v-model="queryCondition.issueDateTo" type="date" :placeholder="'Select Date'" style="width: 100%;"></el-date-picker>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-col>
          </el-collapse-transition>
        </el-row>
        <el-row type="flex" justify="center" align="middle">
          <el-button size="mini" @click="queryCondition.pageNum = 1,queryData()" type="primary">Search</el-button>
          <el-button size="mini" @click="restQueryForm" type="primary">Reset</el-button>
          <span class="arrowDown" @click="isShow=!isShow">{{isShow?'收缩':'展开'}}<i :class="isShow?'el-icon-arrow-up iconBtn':'el-icon-arrow-down iconBtn'"></i></span>
        </el-row>
      </el-form>
    </div>
    <div class="action-btn-row">
      <el-button size="mini" class="btn" v-acl="Create_SSR" @click="newBuilt" type="primary">New</el-button>
    </div>
    <el-table :data="tableList" row-key="ttSsrId" ref="tableList" border highlight-current-row max-height='420'>
      <el-table-column fixed sortable type="selection" width="55" align="center" :reserve-selection="true"></el-table-column>
      <!--SSR编号-->
      <el-table-column show-overflow-tooltip prop="no" :label="$t(`${type}Manage.${type}No`)">
        <template slot-scope="scope">
          <div class="a-link" @click="toDetail(scope.row.ttSsrId)">{{scope.row.serialNo}}
          </div>
        </template>
      </el-table-column>
      <!--SSR名称-->
      <el-table-column show-overflow-tooltip prop="name" :label="$t(`${type}Manage.${type}Name`)"></el-table-column>
      <!--创建人-->
      <el-table-column show-overflow-tooltip prop="creator" :label="'Initiator'"></el-table-column>
      <!--            &lt;!&ndash;更新时间&ndash;&gt;-->
      <!--            <el-table-column prop="issueDate" :label="'Update Date'">-->
      <!--                <template slot-scope="scope">{{scope.row.issueDate|dateFormatFilter("YYYY-MM-DD")}}</template>-->
      <!--            </el-table-column>-->
      <!--状态-->
      <el-table-column show-overflow-tooltip prop="status" :label="'Status'">
        <template slot-scope="scope">{{status(scope.row)}}</template>
      </el-table-column>
      <!--Spec上传-->
      <el-table-column show-overflow-tooltip prop="isSpecUpload" :label="$t('ssrManage.specUpload')"></el-table-column>
      <!--SSR发起-->
      <el-table-column show-overflow-tooltip prop="status" :label="$t(`${type}Manage.${type}Initiate`)">
        <template slot-scope="scope">
          {{(scope.row.issueDate == null?0:1) | ic("COMMON","YES_NO_NUMBER")}}
        </template>fpaPdfDownload
      </el-table-column>
      <!--供应商提案-->
      <el-table-column show-overflow-tooltip prop="proposal" :label="$t('ssrManage.proposal')" width="80" align="center">
        <template slot-scope="scope">
          {{scope.row.currentRound|romanNum}}
        </template>
      </el-table-column>
      <!--Recommendation-->
      <el-table-column show-overflow-tooltip prop="recommendation" :label="$t('ssrManage.recommendation')" width="130">
        <template slot-scope="scope">
          {{(["RECOMMENDATION","BC_CREATED"].includes(scope.row.status)?1:0)| ic("COMMON","YES_NO_NUMBER")}}
        </template>
      </el-table-column>
      <!--BC-->
      <el-table-column show-overflow-tooltip prop="bc" :label="$t('ssrManage.bc')">
        <template slot-scope="scope">
          {{(scope.row.ttBcId!=null?1:0)| ic("COMMON","YES_NO_NUMBER")}}
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination">
      <el-pagination @size-change="pageSizeChange" @current-change="pageNumberChange" :current-page="queryCondition.pageNum" :page-sizes="pageSizeList" :page-size="queryCondition.pageSize" :layout="pageLayout" :total="totalCount"></el-pagination>
    </div>
  </div>
</template>
<script>
import IcSelect from "@/components/common/icSelect";
import commonFunction from "@/utils/dataTableUtils";
import { apiService } from "@/api/ssr-manage/ssr-manage";
import commonFun from "@/utils/commonFun";
import { apiService as materialService } from "@/api/material/material-master-data";

export default {
  components: { IcSelect },
  name: "ssr-manage",
  data() {
    return {
      dataArr: [],
      isShow: false,//控制查询列表收缩展开
      queryCondition: {
        pageSize: 15,
        pageNum: 1,
        serialNo: null,
        name: null,
        creator: null,
        issueDateFrom: null,
        issueDateTo: null,
        category1Id: null,
        category2Id: null
      },
      categoryList1: [],
      categoryList2: [],
      tableList: [{
        ssrNo: 'S20200630001',
        ssrName: '项目一',
      }]

    };
  },
  computed: {
    type() {
      return this.$route.meta.type;
    },
    status() {
      return function (row) {
        let status = row.status;
        switch (row.status) {
          case "DRAFT":
            status = "NEW";
            break;
          case "SUBMIT":
          case "ISSUED":
          case "SUPPLIER_SUBMIT":
          case "MARKED":
          case "BC_CREATED":
            status = "PROCESSING";
            break;
          case "RECOMMENDATION":
            if (row.type == 'SSR') {
              status = "PROCESSING";
            } else {
              status = "END";
            }
            break;
          case "FINISH":
            status = "END";
            break;
          case "SUSPEND":
            status = "TERMINATION";
            break;
        }
        return commonFun.getICVal("TT_SSR", "STATUS_VIEW", status);
      }
    }
  },
  created() {
    this.getCategoryList();
    this.queryData();
  },
  watch: {
    "$route.meta.type": function (val) {
      this.queryData();
    }
  },
  methods: {
    queryData() {
      (this.queryCondition.beginDate = !!this.dataArr
        ? this.$options.filters["dateFormatFilter"](this.dataArr[0])
        : ""),
        (this.queryCondition.endDate = !!this.dataArr
          ? this.$options.filters["dateFormatFilter"](this.dataArr[1])
          : ""),
        this.queryCondition.type = this.type.toUpperCase();
      apiService.search(this.queryCondition).then(res => {
        this.tableList = res.data.records;
        this.totalCount = res.data.total;
      });
    },
    restQueryForm: function () {
      this.$refs.queryCondition.resetFields();
      this.queryCondition = {
        pageSize: 15,
        pageNum: 1,
        serialNo: null,
        name: null,
        creator: null,
        issueDateFrom: null,
        issueDateTo: null,
        category1Id: null,
        category2Id: null
      }
      this.queryData();
    },
    //新增
    newBuilt() {
      let that = this;
      this.$router.push({
        name: `${that.type}-manage-add`,
        query:{
          params:"new"
        }
      });
    },
    //根据角色跳SS明细或者供应商明细
    toDetail(ssrId) {
      let that = this;
      this.$router.push({
        name: commonFun.isSupplier() ? `${that.type}-manage-detailSupp` : `${that.type}-manage-detailSs`,
        query:{
          id: ssrId,
          params:"edit"
        }
      });
    },
    getCategoryList() {
      materialService.findCategory({ categoryLevel: 1, typeList: ['common', 'Logistic'] }).then((res) => {
        this.categoryList1 = res.data;
      });
    },
    //根据选中Category1查询Category2
    changeCategory1() {
      this.queryCondition.category2Id = null
      this.categoryList2 = []
      let that = this;
      materialService.findCategory({ categoryLevel: 2, pid: that.queryCondition.category1Id, typeList: ['common', 'Logistic'] }).then((res) => {
        that.categoryList2 = res.data;
      });
    },
  },
  extends: commonFunction
};
</script>
<style lang="scss">
</style>
